import React from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/index';
import { useTranslation } from 'react-i18next';

const ReadAllDownloadButton = (props) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const deleteAllUnreadInfo = () => dispatch( actions.deleteAllDocumentationFileUserInfo() );

    return (
      <button onClick={ () => { deleteAllUnreadInfo() } } type="button" className="btn-dashboard">{ t('button.downloads.all_read') }</button>
    )
}


export default ReadAllDownloadButton;



// WEBPACK FOOTER //
// ./src/components/Documentations/ReadAllDownloadButton.js